<template>
  <div class="relative bg-blue-100 pb-6 overflow-hidden">
    <!-- Hero Section -->
    <div
      class="flex flex-col items-center pt-12 pb-16 px-6 sm:px-12 lg:px-24 text-center bg-cover bg-center"
      :style="{ backgroundImage: `url(${require('@/assets/img/bannerAzul.png')})` }">
      <h4 class="text-6xl font-serif font-bold text-yellow-400 animate__animated animate__fadeInBottomRight">
        ¿Listo para aumentar tus ventas?
      </h4>
      <img src="@/assets/img/vsc.png" alt="publicidad"
        class="w-40 h-30 mx-auto mt-4 animate__animated animate__fadeInUp">
      <p class="mt-6 text-lg text-white max-w-3xl animate__animated animate__fadeInBottomLeft">
        Juntos reactivando la economia local, aumentando las ventas y empoderando al consumidor con
        <b>Virtual Shopping Club</b>.
        <br><b>¡El momento de
          crecer es ahora!</b>
      </p>
      <router-link :to="registroRoute" class="mt-6 px-8 py-3 bg-red-500 text-white font-bold text-lg rounded-full
                                hover:bg-green-500 hover:text-white transition-all">
        ¡Regístrate Ahora!
      </router-link>
    </div>

    <!-- Video Explicativo -->
    <div class="py-16 bg-blue-100 text-center">

      <!-- Video de YouTube -->
      <div class="mx-auto max-w-4xl px-6 lg:px-8">
        <div class="aspect-w-16 aspect-h-9">
          <iframe class="absolute rounded-lg  top-0 left-0 w-full h-full"
            src="https://www.youtube.com/embed/M4o5Zc7c3fQ" frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
    </div>

    <!--pocas ventas-->
    <div class=" mx-auto text-center">
      <div class="bg-white p-6 rounded-lg shadow-lg text-center border border-gray-100">
        <h3 class="text-xl font-bold text-red-500">❌ ¿Pocas ventas y clientes que solo compran una vez?</h3>
        <p class="text-gray-700 mt-2 text-center">
          Si los clientes llegan, compran una vez y no vuelven, necesitas una estrategia diferente.
        </p>
      </div>
    </div>

    <!-- Sección de Beneficios -->
    <div class="py-16">
      <div class="max-w-4xl mx-auto px-6 lg:px-12 mb-14 text-center">
        <p
          class="text-lg md:text-xl text-gray-700 leading-relaxed bg-white border-l-4 border-r-4 border-blue-600 p-4 rounded-xl shadow-sm">
          Sé parte de <strong class="text-blue-600">Virtual Shopping Club</strong>,
          una aplicación móvil que convierte los gastos comunes —tuyos o de
          tus conocidos—
          en una nueva forma de generar <span class="font-semibold text-blue-600">ingresos constantes</span>.
        </p>
      </div>

      <div class="max-w-5xl mx-auto px-6 lg:px-12 mb-14 text-center">
        <h1 class="text-3xl text-gray-700 font-semibold">¡Únete al <span class="font-bold text-yellow-500">Club de Negocios</span> y lleva tu empresa al siguiente
          nivel</h1>
        <p class="text-lg md:text-xl text-gray-700  p-4 rounded-xl ">
          Al formar parte del <strong class="text-yellow-500">Club de Negocios</strong>
          tu negocio accederá a ventas efectivas, publicidad permanente y la posibilidad de generar ingresos extras de
          forma constante. <br><br>
          Y eso no es todo: si estás entre los primeros 100 negocios en unirse, recibirás el reconocimiento especial
          como <span class=" font-bold text-yellow-500">Miembro Fundador del Club</span>, lo que te brindará ventajas
          exclusivas y prioridad en futuras oportunidades.
        </p>
      </div>

      <h2 class="text-4xl font-serif font-bold text-center text-cyan-700 mb-12">
        En Virtual Shopping Club obtienes acceso a <span class="text-yellow-400 font-bold">3 tecnologías
          exclusivas</span> que impulsarán tu negocio:
      </h2>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto px-6 lg:px-12">
        <div class="bg-white border border-blue-400 p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition">
          <h3 class="text-2xl font-serif font-semibold text-cyan-800">🎟️ Campaña de cupones</h3>
          <p class="mt-2 text-gray-600">
            Con nuestras campañas tendrás una forma muy efectiva de atraer nuevos clientes, dar a conocer tu
            negocio y potencializar tus ventas efectivas.
          </p>
        </div>

        <div class="bg-white border border-blue-400 p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition">
          <h3 class="text-2xl font-serif font-semibold text-cyan-800">🏆 Centro de canje de puntos</h3>
          <p class="mt-2 text-gray-600">
            Al ser tu negocio un centro de canje de puntos vas a obtener clientes fieles, tecnificación de
            tu negocio y ventaja competitiva con negocios externos.
          </p>
        </div>

        <div class="bg-white border border-blue-400 p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition">
          <h3 class="text-2xl font-serif font-semibold text-cyan-800">🤝 Patrocinador F3</h3>
          <p class="mt-2 text-gray-600">
            Una tecnología solo para <span class="font-semibold text-cyan-800">miembros fundadores</span>
            con la cual podras recibir ingresos pasivos por las ventas y cupones aplicados en la zona de tu
            ciudad de residencia.
          </p>
        </div>
      </div>
    </div>

    <!--Que tengo que hacer-->
    <div class="py-16">
      <h2 class="text-4xl font-serif font-bold text-center text-cyan-700 mb-6">
        ¿Qué tengo que hacer?
      </h2>
      <div class="grid gap-8 max-w-7xl mx-auto px-6 lg:px-12">
        <div
          class="bg-white border border-blue-400 p-8 rounded-2xl shadow-lg text-center hover:shadow-xl transition duration-300">
          <h3 class="text-2xl font-serif font-semibold text-cyan-800 mb-4">
            ¡Empieza en 3 pasos!
          </h3>
          <p class="text-gray-700 mb-4">
            <strong>1.</strong> Selecciona 2 de los negocios para obtener 2 cupones con 50 en saldo para descuento cada
            uno y regístrate totalmente.<br>
            <strong>2.</strong> Descarga la app desde tu tienda de aplicaciones favorita e inicia sesión con tu
            cuenta.<br>
            <strong>3.</strong> Contacta a tu asesor para recibir información de como integrarte al club de negocios y
            comenzar a generar ingresos.
          </p>
          <p class="text-gray-600 italic">
            ¡Es rápido, sencillo y sin costo!
          </p>
        </div>
      </div>
    </div>


    <!--Selecciona tu ubicacion-->
    <div class="bg-white p-6 max-w-2xl mx-auto rounded-2xl space-y-2" v-if="$route.name === 'club-negocios5'">
      <h2 class="text-3xl font-bold text-center text-cyan-700 mb-4">Selecciona tu ubicación para ver los negocios
        participantes</h2>
      <div class="flex flex-wrap gap-4 justify-center">

        <!-- Select País -->
        <div class="w-full sm:w-auto">
          <label class="block mb-1 text-gray-700">País</label>
          <select v-model="selectedCountry" @change="fetchStates"
            class="w-full p-2 border border-gray-500 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-500">
            <option value="" disabled>Seleccione un país</option>
            <option v-for="pais in paises" :key="pais.id" :value="pais">
              {{ pais.nombre }}
            </option>
          </select>
        </div>

        <!-- Select Estado -->
        <div v-if="estados.length" class="w-full sm:w-auto">
          <label class="block mb-1 text-gray-700">Estado</label>
          <select v-model="selectedState" @change="fetchMunicipios"
            class="w-full p-2 border border-gray-500 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-500">
            <option value="" disabled>Seleccione un estado</option>
            <option v-for="estado in estados" :key="estado.id" :value="estado">
              {{ estado.nombre }}
            </option>
          </select>
        </div>

        <!-- Select Municipio -->
        <div v-if="municipios.length" class="w-full sm:w-auto">
          <label class="block mb-1 text-gray-700">Municipio</label>
          <select v-model="selectedMunicipio" @change="fetchNegocios()"
            class="w-full p-2 border border-gray-500 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-500">
            <option value="" disabled>Seleccione un municipio</option>
            <option v-for="municipio in municipios" :key="municipio.id" :value="municipio">
              {{ municipio.nombre }}
            </option>
          </select>
        </div>

      </div>
    </div>

    <!-- negocios participantes -->
    <h2 id="business-section" class="text-4xl mt-6 mb-4 px-2 font-bold text-cyan-700 text-center">Negocios
      participantes para aplicar tus cupones de descuento</h2>
    <p class="text-lg text-center" v-if="nombreRegion !== null">
      <span class="text-gray-700 ">Región </span><span class="font-bold text-gray-800">{{ nombreRegion }}</span>
    </p>

    <!-- Mostrar negocios disponibles -->
    <section v-if="negocios.length"
      class="bg-gray-200 pt-4 pb-4 border border-gray-400 rounded-lg max-w-6xl grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-8 px-6 overflow-auto mx-auto max-h-96 mt-4">
      <div v-for="negocio in negocios" :key="negocio.id" @click="toggleNegocioSeleccionado(negocio)" :class="[
        'relative flex flex-col justify-between items-center p-2 rounded-lg cursor-pointer transition-all h-full',
        isSeleccionado(negocio) ? 'bg-green-400' : 'bg-white hover:bg-gray-100',
        negocio.alto_impacto ? 'border-2 border-green-400 shadow-lg shadow-green-500' : ''
      ]" style="min-height: 220px;">

        <div class="flex flex-col items-center relative w-full">
          <!-- Etiqueta de descuento con espacio -->
          <div v-if="negocio.porcentaje"
            class="self-end mb-2 bg-red-500 text-white text-xs font-bold px-2 py-1 -mt-1 -mr-6 rotate-[35deg] rounded shadow-md z-10">
            {{ negocio.porcentaje }}% Desc.
          </div>
          <!-- Logo -->
          <img :src="negocio.logo_url" alt="Logo del negocio"
            class="w-full max-w-[120px] max-h-[120px] object-contain mb-2 rounded-lg" />
          <!-- Nombre -->
          <span class="text-center font-bold">{{ negocio.nombre }}</span>
        </div>


        <button @click.stop="mostrarInformacion(negocio)"
          class="mt-4 text-sm bg-blue-500 text-white px-3 py-1 rounded-full hover:bg-blue-600 w-full">
          ℹ️&nbsp;Información 
        </button>
      </div>
    </section>

    <!-- Sección de Cupones Seleccionados -->
    <section v-if="negociosSeleccionados.length"
      class="mt-6 bg-white p-6 rounded-2xl shadow-lg max-w-5xl mx-auto border border-gray-300">
      <h3 class="text-3xl font-extrabold mb-6 text-center text-cyan-500">🎉 Tus cupones seleccionados</h3>
      <div class="flex flex-wrap justify-center gap-6">
        <div v-for="negocio in negociosSeleccionados" :key="negocio.id" class="w-[280px] sm:w-[300px] bg-white p-4 rounded-2xl shadow-md border-2 border-dashed border-blue-400 
                flex flex-col items-center gap-3 transition-transform hover:scale-105">

          <img :src="negocio.logo_url" alt="Logo del negocio"
            class="w-full max-w-[140px] max-h-[140px] object-contain rounded-lg shadow bg-white" />
          <span class="text-gray-600 text-center">Cupón de descuento para: </span>
          <span class="text-lg font-bold text-center text-gray-800">{{ negocio.nombre }}</span>
        </div>
      </div>

      <!-- Transición del botón -->
      <transition name="fade-slide">
        <router-link v-if="negociosSeleccionados.length === 2" :to="registroRoute" class="block text-center mt-10 px-8 py-4 bg-cyan-500 text-white text-lg font-bold rounded-xl
                        shadow-xl hover:bg-cyan-600 transition-all duration-300">
          ¡Obtener cupones!
        </router-link>
      </transition>
    </section>

    <!-- Sólo mostrar cuando la liga tenga una región asociada -->
    <div class="p-6 max-w-2xl mx-auto bg-gray-100 rounded-2xl shadow-md space-y-2 mt-12"
      v-if="$route.name === 'promociones-con-region'">
      <h2 class="text-2xl font-bold text-center text-gray-800 mb-4">
        Selecciona otra ubicación para ver los negocios participantes
      </h2>
      <div class="flex flex-wrap gap-4 justify-center">

        <!-- Select País -->
        <div class="w-full sm:w-auto">
          <label class="block mb-1 text-gray-700">País</label>
          <select v-model="selectedCountry" @change="fetchStates"
            class="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
            <option value="" disabled>Seleccione un país</option>
            <option v-for="pais in paises" :key="pais.id" :value="pais">
              {{ pais.nombre }}
            </option>
          </select>
        </div>

        <!-- Select Estado -->
        <div v-if="estados.length" class="w-full sm:w-auto">
          <label class="block mb-1 text-gray-700">Estado</label>
          <select v-model="selectedState" @change="fetchMunicipios"
            class="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
            <option value="" disabled>Seleccione un estado</option>
            <option v-for="estado in estados" :key="estado.id" :value="estado">
              {{ estado.nombre }}
            </option>
          </select>
        </div>

        <!-- Select Municipio -->
        <div v-if="municipios.length" class="w-full sm:w-auto">
          <label class="block mb-1 text-gray-700">Municipio</label>
          <select v-model="selectedMunicipio" @change="fetchNegocios()"
            class="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
            <option value="" disabled>Seleccione un municipio</option>
            <option v-for="municipio in municipios" :key="municipio.id" :value="municipio">
              {{ municipio.nombre }}
            </option>
          </select>
        </div>

      </div>
    </div>



    <!-- Programa de Ingresos Extras -->
    <div class="py-16 mt-12 bg-linear-to-r from-cyan-500 to-blue-500 text-white text-center">
      <h2 class="text-4xl font-serif font-bold">💸 Tus ventas no tienen que ser tu única <span
          class="text-yellow-400">fuente de ingresos.</span></h2>
      <p class="mt-6 max-w-4xl mx-auto text-lg px-2">
        Con el <b>Programa Fusión</b>, tu negocio desbloquea una nueva fuente de ingresos diseñada para
        brindarte <b>publicidad permanente</b>, <b>tecnificación de tu negocio</b> y un <b>flujo de ganancias que
          puede ir desde pequeños ingresos hasta cifras ilimitadas</b>.
        <br><br>
        Todo comienza al conectar personas y negocios a Virtual Shopping Club. Cuanto más compartes esta
        oportunidad, más crecen tus beneficios y el alcance de tu negocio.
      </p>

      <img src="@/assets/img/ingresosExt.png" alt="Ingresos" class="w-40 mx-auto my-6">
      <router-link :to="registroRoute"
        class="px-8 py-4 bg-white text-cyan-800 font-bold text-lg rounded-full hover:bg-green-500 hover:text-white transition">
        ¡Descubre cómo funciona!🔥
      </router-link>
    </div>

    <!-- Membresia y Programa f3 -->
    <div class=" max-w-4xl mx-auto text-center bg-orange-500 rounded-lg p-6 mt-2 bg-cover bg-center"
      :style="{ backgroundImage: `url(${require('@/assets/img/fondoAzul.png')})` }">
      <div class="max-w-7xl mx-auto px-6 lg:px-8">
        <img src="@/assets/img/cardVSC.png" alt="Icono de publicidad" class="w-75 h-54 mx-auto mb-5">
        <h2 class="neon-black text-3xl font-serif font-extrabold text-center text-white mb-5 ">
          Únete al club y aumenta tus ventas
        </h2>
        <p class="neon-black text-white text-lg leading-relaxed mb-12">
          Como miembro del Club de Negocios, convierte tu marca en la favorita de nuestros clientes, con la
          membresia anual
          tu negocio tendrá mayores beneficios en publicidad, ventas efectivas,
          ingresos extras y acceso a <span class="font-semibold">2 tecnologias</span> como la
          campaña de cupones y ser centro de canje de puntos, las cuales te ayudarán a incrementar tus ganacias desde
          pesitos a más
          de $1,000,000 en ventas efectivas.
          Aparte, contarás con
          el apoyo de un experto en ventas y marketing. <br><br>
        </p>

        <h2 class="neon-black text-3xl font-serif font-extrabold text-center text-white mb-5 ">
          Convierte en <span class="text-cyan-500">miembro Fundador</span> del club de negocios
        </h2>
        <p class="neon-black text-white text-lg leading-relaxed mb-12">
          <span class="font-bold">🎁 Sé de los primeros 100 negociós de la zona en unirse</span><br>
          Obtén de cortesía la tecnologia F3 con la cual podrás recibir ingresos <span
            class="font-semibold text-green-500">pasivos</span> de todas las <span
            class="font-semibold text-green-500">ventas y cupones</span> aplicados en negocios
          afiliados de una zona de México. No tienes que vender nada, solo aprovechar el
          movimiento de la red de negocios. ¡Así de fácil! 💰🚀
        </p>

        <router-link :to="registroRoute" class="inline-block px-8 py-3 bg-white text-blue-700 font-bold text-lg rounded-lg
                                    shadow-lg hover:bg-green-600 hover:text-white transform hover:scale-105
                                    transition-all duration-300 mb-6">
          ¡Aprovecha esta oferta exclusiva!
        </router-link>
      </div>
    </div>

    <!--por que unirse-->
    <section class="py-12 mt-8">
      <div class="max-w-4xl mx-auto text-center">
        <h2 class="text-3xl font-bold text-cyan-700 mb-6">💡 ¿Por qué unirte?</h2>

        <div class="grid grid-cols-1 md:grid-cols-4 gap-6">
          <!-- Carga Administrativa Pesada -->
          <div
            class="bg-linear-to-b from-blue-500 to-cyan-500 p-6 rounded-lg shadow-lg text-center border border-blue-400 hover:border-blue-700">
            <h3 class="text-xl font-bold text-white">✅ Ventas recurrentes</h3>
            <p class="text-white mt-2 text-justify">Con el programa de cupones los clientes obtienen descuentos de tus
              productos y puntos por comprar contigo, eso los motiva a regresar a tu negocio, aparte tienes la
              posibilidad de recuperar los descuentos que apliques.</p>
          </div>

          <!-- Falta de Personalización -->
          <div
            class="bg-linear-to-b from-blue-500 to-cyan-500 p-6 rounded-lg shadow-lg text-center border border-blue-400 hover:border-blue-700">
            <h3 class="text-xl font-bold text-white">✅ Más publicidad, sin complicaciones</h3>
            <p class="text-white mt-2 text-justify">Te ayudamos a que más personas, dentro y fuera de la comunidad de
              Virtual Shopping Club, conozcan tu marca y aumentes su presencia en el mercado, a través de tres
              tecnologías exclusivas para negocios..</p>
          </div>

          <div
            class="bg-linear-to-b from-blue-500 to-cyan-500 p-6 rounded-lg shadow-lg text-center border border-blue-400 hover:border-blue-700">
            <h3 class="text-xl font-bold text-white">✅ Clientes fieles</h3>
            <p class="text-white mt-2 text-justify">Olvídate de los clientes que solo compran una vez. En
              nuestro club conectarás con
              clientes que regresan y recomiendan.</p>
          </div>

          <div
            class="bg-linear-to-b from-blue-500 to-cyan-500 p-6 rounded-lg shadow-lg text-center border border-blue-400 hover:border-blue-700">
            <h3 class="text-xl font-bold text-white">✅ Gana dinero por recomendarnos.</h3>
            <p class="text-white mt-2 text-justify">Genera ingresos recomendando <b>Virtual Shopping Club</b> a tus
              amigos, clientes y conocidos.
              Cuantas más personas invites a unirse, <b>mayores serán tus ganancias</b>. ¡Convierte tus
              conexiones en oportunidades reales de crecimiento!</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Sección de Preguntas Frecuentes -->
    <div class="py-16 px-6 text-center text-gray-800">
      <h3 class="text-3xl font-bold text-cyan-700"> Preguntas Frecuentes</h3>
      <details class="mt-6 bg-white p-4 rounded-lg shadow-md">
        <summary class="font-semibold text-lg cursor-pointer"> ¿Qué necesito para unirme al club?</summary>
        <p class="mt-2">Solo necesitas tener un negocio físico, una actitud amable y de servicio, autorizar tu
          marca o negocio para medios publicitarios ¡y listo!
          obtén tu participacion en la campaña de negocios o tu membresia de negocios y disfrutar de los
          beneficios.</p>
      </details>
      <details class="mt-6 bg-white p-4 rounded-lg shadow-md">
        <summary class="font-semibold text-lg cursor-pointer"> ¿Qué negocios pueden participar?</summary>
        <p class="mt-2">¡Cualquiera! No importa si vendes un producto o prestas un servicio, puedes unirte al
          club.
          Lo único que necesitas es que tu negocio sea legal, pueda emitir facturas y des un minimo de 10% de
          descuento a los miembros del club y cubrir la aportacion inicial.</p>
      </details>
      <details class="mt-6 bg-white p-4 rounded-lg shadow-md">
        <summary class="font-semibold text-lg cursor-pointer"> ¿Dónde se mostrará la publicidad de mi negocio?
        </summary>
        <p class="mt-2">Tu negocio se beneficiará de campañas en redes sociales, publicidad orgánica a través de las
          cuentas
          de nuestros socios, y materiales promocionales diseñados para destacar tu marca. Además, tendrás
          presencia dentro de la aplicación <b>Virtual Shopping Club</b>, aumentando tu visibilidad ante
          nuevos clientes de forma constante.</p>
      </details>
      <details class="mt-6 bg-white p-4 rounded-lg shadow-md">
        <summary class="font-semibold text-lg cursor-pointer"> No sé mucho de marketing, ¿es necesario para
          unirme al club?</summary>
        <p class="mt-2"> ¡Para nada! No importa si eres experto en marketing o no. Aquí trabajarás con un
          experto que te ayudará con las ventas, publicidad y hacer crecer tus contactos.</p>
      </details>
    </div>

    <!-- Llamada a la acción -->
    <div class="bg-linear-to-r from-blue-500 to-cyan-500 py-16 relative z-20 mt-14">
      <div class="max-w-7xl mx-auto text-center px-4 sm:px-6 lg:px-8">
        <h2 class="text-4xl text-white font-serif font-extrabold text-white animate-pulse">
          💸 ¡Ventas aseguradas para tu negocio! 💸
        </h2>
        <img src="@/assets/img/vsc.png" alt="publicidad" class="w-40 h-30 mx-auto mt-4 mb-4">
        <router-link :to="registroRoute" class="inline-block px-8 py-4 bg-white text-cyan-800 font-bold text-lg rounded-full
                                    shadow-lg hover:bg-green-500 hover:text-white transform hover:scale-105
                                    transition-all duration-300">
          ¡Quiero mas ventas!
        </router-link>
      </div>
    </div>


  </div>
</template>


<script>

export default {
  data() {
    return {
      paises: [],
      estados: [],
      municipios: [],
      negocios: [],
      selectedCountry: '',
      selectedState: '',
      selectedMunicipio: '',
      mostrarNoNegocios: false, // Nueva variable para controlar la visibilidad

      noPatrocinador: "",
      nombreRegion: null,
      negociosSeleccionados: [],

      inicioCupones: null,
      countdown: {
        dias: 0,
        horas: 0,
        minutos: 0,
        segundos: 0
      },
      intervaloCountdown: null
    };
  },
  props: {
    patrocinadores: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    // Obtener fecha de inicio de cupones y arrancar el contador
    async fetchInicioCupones() {
      await this.axios.get("/api/v2/cupones").then((response) => {
        if (response.data.inicio_cupones) {
          this.inicioCupones = new Date(response.data.inicio_cupones)
          this.startCountdown()
        } else {
          this.inicioCupones = null
        }
      }).catch(() => {
        this.inicioCupones = null
      })
    },

    startCountdown() {
      if (this.intervaloCountdown) clearInterval(this.intervaloCountdown)

      this.intervaloCountdown = setInterval(() => {
        const ahora = new Date()
        const diferencia = this.inicioCupones - ahora

        if (diferencia <= 0) {
          clearInterval(this.intervaloCountdown)
          this.countdown = { dias: 0, horas: 0, minutos: 0, segundos: 0 }
          return
        }

        const segundosTotales = Math.floor(diferencia / 1000)
        this.countdown.dias = Math.floor(segundosTotales / (60 * 60 * 24))
        this.countdown.horas = Math.floor((segundosTotales / (60 * 60)) % 24)
        this.countdown.minutos = Math.floor((segundosTotales / 60) % 60)
        this.countdown.segundos = segundosTotales % 60
      }, 1000)
    },



    // Alternar la selección de un negocio
    toggleNegocioSeleccionado(negocio) {
      const index = this.negociosSeleccionados.findIndex((n) => n.id === negocio.id)

      if (index !== -1) {
        // Si ya está seleccionado, lo deselecciona
        this.negociosSeleccionados.splice(index, 1)
      } else if (this.negociosSeleccionados.length < 2) {
        // Si no está seleccionado y hay espacio, lo selecciona
        this.negociosSeleccionados.push(negocio)
      } else {
        alert("Solo puedes seleccionar 2 cupones.")
      }
    },

    // Verificar si un negocio está seleccionado
    isSeleccionado(negocio) {
      return this.negociosSeleccionados.some((n) => n.id === negocio.id)
    },

    //Mostrar informacion del negocio
    mostrarInformacion(negocio) {
      const esUnaUbicacion = Array.isArray(negocio.ubicaciones) && negocio.ubicaciones.length === 1;
      const textoDirecciones = esUnaUbicacion ? 'Dirección' : 'Direcciones';
      this.$swal({
        title: '',
        html: `
    <div style="display: flex; justify-content: center; margin-bottom: 15px; animation: fadeInZoom 0.6s ease;">
      <img src="${negocio.logo_url}" alt="Logo" style="max-width: 120px; max-height: 120px; border-radius: 12px;" />
    </div>

    <h2 style="color: #1e293b; font-size: 1.6rem; font-weight: 700; text-align: center; margin-bottom: 12px; animation: fadeIn 0.5s ease;">
      ${negocio.nombre}
    </h2>

    <p style="color: #334155; margin-bottom: 18px; text-align: center; animation: fadeIn 0.7s ease;">
      <strong>📄 Descripción:</strong> ${negocio.descripcion || 'No especificada'}
    </p>

    <div style="margin-top: 15px; color: #334155; text-align: center; animation: fadeInUp 0.8s ease;">
      <strong style="display: block;  margin-bottom: 10px; font-size: 1.1rem;">📍 ${textoDirecciones}:</strong>
      <div style="
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 12px;
        animation: fadeInUp 1s ease;
      ">
        ${Array.isArray(negocio.ubicaciones)
            ? negocio.ubicaciones.map((direccion, index) => `
              <div style="
                background-color: #86FF99;
                padding: 10px 16px;
                border-radius: 10px;
                box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
                font-size: 0.92rem;
                color: #1f2937;
                display: flex;
                align-items: center;
                gap: 6px;
                animation: fadeIn 0.3s ease ${(index + 1) * 0.1}s forwards;
                opacity: 0;
              ">
                📌 ${direccion}
              </div>
            `).join('')
            : '<div style="color: #999;">No especificadas</div>'
          }
      </div>
    </div>
  `,
        confirmButtonText: 'Cerrar',
        confirmButtonColor: '#D20103',
        background: '#FFFFFF',
        showClass: {
          popup: 'swal2-show-animate'
        },
        customClass: {
          popup: 'rounded-xl'
        },
        didOpen: () => {
          // Agrega animación personalizada con clases CSS
          const style = document.createElement('style')
          style.innerHTML = `
      @keyframes fadeInZoom {
        0% { opacity: 0; transform: scale(0.8); }
        100% { opacity: 1; transform: scale(1); }
      }

      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }

      @keyframes fadeInUp {
        0% { opacity: 0; transform: translateY(20px); }
        100% { opacity: 1; transform: translateY(0); }
      }
    `
          document.head.appendChild(style)
        }
      })

    },

    // Obtener países y estados
    async fetchCountries() {
      await this.axios.get("api/v2/negocios-gratuitos/regiones-disponibles.json").then((response) => {
        if (response.data.mapa) {
          this.paises = response.data.mapa
        } else {
          this.paises = []
        }
      }).catch(() => {
        this.paises = []
      })
    },

    // Obtener estados del país seleccionado
    fetchStates() {
      if (this.selectedCountry) {
        this.estados = this.selectedCountry.estados
        this.municipios = []
        this.resetNegocios()
      }
    },

    // Obtener municipios del estado seleccionado
    fetchMunicipios() {
      if (this.selectedState) {
        this.municipios = this.selectedState.municipios
        this.resetNegocios()
      }
    },

    // Obtener negocios del municipio seleccionado
    async fetchNegocios(id = null) {
      if (this.selectedMunicipio || id) {
        this.negociosSeleccionados = []
        const regionId = id || this.selectedMunicipio.id
        localStorage.setItem('regionIdCupones', regionId)
        await this.axios.get(`api/v2/negocios-gratuitos/by-region/${regionId}.json`).then((response) => {
          this.nombreRegion = response.data.nombre_region
          if (response.data.negocios && response.data.negocios.length > 0) {
            this.negocios = response.data.negocios
            this.mostrarNoNegocios = false // Ocultar mensaje si hay negocios
          } else {
            this.negocios = []
            this.mostrarNoNegocios = true // Mostrar mensaje si no hay negocios
          }
        }).catch(() => {
          this.negocios = []
          this.mostrarNoNegocios = true // Mostrar mensaje en caso de error
        })
      }
    },
    //boton de scroll
    scrollToBusinesses() {
      const businessSection = this.$el.querySelector("#business-section")
      if (businessSection) {
        businessSection.scrollIntoView({ behavior: "smooth" })
      }
    },
    resetNegocios() {
      this.negocios = []
      this.nombreRegion = null
      this.negociosSeleccionados = []
      this.mostrarNoNegocios = false
      localStorage.setItem('regionIdCupones', null)
    }
  },
  async mounted() {
    localStorage.setItem('regionIdCupones', null)
    if (this.$route.params.noPatrocinador) {
      this.noPatrocinador = this.$route.params.noPatrocinador
    }
    if (this.$route.name === 'cupones-con-region') {
      localStorage.setItem('regionIdCupones', this.$route.params.regionId)
      await this.fetchNegocios(Number(this.$route.params.regionId))
    }
    if (this.$route.name === 'campania') {
      this.negocios = this.patrocinadores
    } else {
      await this.fetchCountries()
    }
    await this.fetchInicioCupones()
  },
  computed: {
    registroRoute() {
      if (this.$route.name === 'campania') {
        return {
          name: 'registroCampania',
          params: { codigo: this.$route.params.codigo, patrocinadores: this.negociosSeleccionados.map(n => n.id) }
        }
      } else {
        return {
          name: 'registro',
          params: { noPatrocinador: this.noPatrocinador, patrocinadores: this.negociosSeleccionados.map(n => n.id) }
        }
      }
    },
  },
};
</script>

<style scoped>
/* Estilos personalizados */
.neon-text {
  text-shadow: 0 0 90px #ffffff, 0 0 20px #ffffff, 0 0 30px #ffffff;
}

.neon-black {
  text-shadow: 0 0 10px #000000, 0 0 10px #000000, 0 0 20px #000000;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

h1,
h2,
h3 {
  animation: fadeIn 1s ease-in-out;
}

.animated-gradient {
  animation: pulse 2s infinite;
  font-size: 2rem;
  /* Ajusta el tamaño */
  font-weight: 800;
  /* Fuente extrabold */
  text-align: center;
  /* Centrar texto */
  background: linear-gradient(90deg, #ffa52f, #ff9100, #ffa52f);
  /* Gradiente de 3 colores */
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  /* El gradiente aparecerá en lugar del color sólido */
  animation: gradient-animation 3s infinite;
  /* Añade la animación */
}

@keyframes gradient-animation {

  0%,
  100% {
    background-position: 0% 50%;
    transform: scale(0.8);
  }

  50% {
    background-position: 100% 50%;
    transform: scale(0.9);
  }
}
</style>